import {List} from 'antd';
import React from 'react';

export function ItemSectionFragment(props) {
  const { title, description } = props;
  return (
    <List.Item>
      <List.Item.Meta title={title} description={description} />
    </List.Item>
  );
}
